import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowUpSmall = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g transform="rotate(-90 8 8)">
        <g transform="translate(2 2)">
          <g transform="translate(3)">
            <path d="M6.707 6.707l-5 5a1 1 0 1 1-1.414-1.414L4.586 6 .293 1.707A1 1 0 1 1 1.707.293l5 5a1 1 0 0 1 0 1.414z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

ArrowUpSmall.displayName = 'ArrowUpSmall';
